import { IBaseIconProps } from "./IBaseIconProps";

/**
 * A lightning bolt: the one-tap ("quick") version of an action. Drawn smaller than its box and
 * centred in it, so it sits level with the row's other action icons.
 */
export const BoltIcon = ({ color = "currentColor" }: IBaseIconProps) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.7 5.3L6.8 13.1H11.3L10.6 18.7L17.2 10.3H12.7L12.7 5.3Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
};
